module.exports = {
  ...require("./brandConfig"),
  ...require("./resolveBrand"),
  ...require("./interpolateBrand"),
};
